import React from 'react'
import { Nav, Navbar } from 'react-bootstrap'


class NavBar extends React.Component {

    render() {
        return (

            <Navbar className='navbar navbar-expand navbar-theme'>
                <a
                    className='sidebar-toggle d-flex me-2'
                    onClick={this.props.toggle}
                ><i className="hamburger align-self-center"></i></a>

                <div className='navbar-collapse collapse'>
                    <Navbar.Collapse id='responsive-navbar-nav'>
                        <Nav className='navbar-nav ms-auto' navbar>
                            <Nav.Link className='nav-item dropdown'>&nbsp;</Nav.Link>
                            <Nav.Link className='nav-item dropdown'>&nbsp;</Nav.Link>
                            <Nav.Link className='nav-item dropdown'>&nbsp;</Nav.Link>
                            <Nav.Link className='nav-item dropdown'>&nbsp;</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </div>
            </Navbar>

        )
    }

}

export default NavBar;